import { useEffect } from 'react';

import { NotFoundListingSearch } from '@assets/icons';
import Typography from '@components/Typography';
import CustomIcon from '@components/utils/CustomIcon';
import { useDevice } from '@contexts/device';
import { logNotFoundPage } from '@utils/gtm/error-log-gtm';

import { TextWrapper, Container } from './style';

type Props = {
  label: string;
  description: string;
};

const NotFoundListingSearchBanner = ({ label, description }: Props) => {
  const { isDesktop } = useDevice();
  useEffect(() => {
    logNotFoundPage();
  }, []);
  return (
    <Container>
      <CustomIcon
        icon={NotFoundListingSearch}
        width={isDesktop ? 100 : 67}
        height={isDesktop ? 60 : 40}
      />
      <TextWrapper>
        <Typography variant='caption1' weight='Regular' color='D400'>
          {label}
        </Typography>
        <Typography variant='caption1' weight='Regular' color='D400'>
          {description}
        </Typography>
      </TextWrapper>
    </Container>
  );
};

export default NotFoundListingSearchBanner;
